
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Keyboard, TouchableHighlight, StyleSheet, View, Text, Platform } from 'react-native';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
const isWeb = Platform.OS === 'web';

export default class Button extends PureComponent {
    constructor(props) {
        super(props);
        this.lastTimeStamp = 0;
        this.state = {
            isActive: false // 点击中
        };
        this.defaultColor = props.defaultColor || ['#F10000', '#FF2000', '#FF4F18']; // 正常态
        this.activeColor = ['#D80000', '#E51C00', '#E54615']; // 点击态
        this.disabledColor = ['#FAB3B3', '#FFBCB3', '#FFCABA']; // 禁止态
        this.locations = props.locations || [0.2, 0.7, 1.0];
    }

    render() {
        const { isActive } = this.state;
        const { width, height, isDisabled, containerStyle, contentStyle, onLayout } = this.props;

        return (
            <View
                style={containerStyle || [st.container, { width: width, height: height }]}
                onLayout={onLayout}
            >
                <LinearGradient
                    style={[{ flex: 1, overflow: 'hidden' }, contentStyle]}
                    start={{ x: 0, y: 0 }}
                    end={{ x: 1, y: 1 }}
                    colors={
                        isDisabled
                            ? this.disabledColor
                            : isActive
                                ? this.activeColor
                                : this.defaultColor
                    }
                    locations={this.locations}
                >
                    <TouchableHighlight
                        style={st.btn}
                        onPress={this.onPress}
                        underlayColor='transparent'
                        onHideUnderlay={this.onHideUnderlay}
                        onShowUnderlay={this.onShowUnderlay}
                    >
                        <View style={st.btn}>
                            {this.renderContent()}
                        </View>
                    </TouchableHighlight>
                </LinearGradient>
            </View>
        );
    }

    onHideUnderlay = () => {
        this.setState({
            isActive: false
        });
    }

    onShowUnderlay = () => {
        this.setState({
            isActive: true
        });
    }

    onPress=() => {
        let { onPress, isDisabled, throttle } = this.props;

        let timeStamp = Date.now();

        !isWeb && Keyboard.dismiss();
        if (!isDisabled && !(timeStamp - global.lastTimeStamp < throttle)) {
            global.lastTimeStamp = timeStamp;
            onPress && onPress();
        }
    }

    renderContent = () => {
        if (typeof this.props.children === 'string') {
            return <Text style={st.btn_text}>{this.props.children}</Text>;
        }
        return this.props.children;
    }
}

Button.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    containerStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    contentStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    onLayout: PropTypes.func,
    onPress: PropTypes.func,
    isDisabled: PropTypes.bool,
    throttle: PropTypes.number,
    children: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string
    ])
};

Button.defaultProps = {
    width: 100,
    height: 30,
    throttle: 1000
};

const st = StyleSheet.create({
    container: {
        flexDirection: 'row',
        borderRadius: 3,
        overflow: 'hidden'
    },
    btn: {
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%'
    },
    btn_text: {
        fontSize: 14,
        color: '#fff'
    }
});
